import {FC, ReactNode} from 'react'
import {useClientPortalAuth} from '../../auth/core/ClientPortalAuth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link, useNavigate, useLocation} from 'react-router-dom'
import '../ClientPortal.css'

interface ClientPortalLayoutProps {
  children: ReactNode
}

const getInitials = (name?: string) =>
  (name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')

const ClientPortalLayout: FC<ClientPortalLayoutProps> = ({children}) => {
  const {user, logout, selectedAccess, setSelectedAccess} = useClientPortalAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const isProjectPage = location.pathname.includes('/project/')

  const hasMultipleInstances =
    !!user?.accesses && new Set(user.accesses.map((acc: any) => acc.instance_id)).size > 1

  const handleLogout = () => {
    logout()
    navigate('/auth/area-do-cliente/login')
  }

  const handleChangeAccess = () => {
    setSelectedAccess(null)
    navigate('/area-do-cliente/select-access')
  }

  return (
    <div className='client-portal d-flex flex-column flex-root app-root' id='kt_app_root'>
      <header className='cp-header'>
        <div className='cp-header-left'>
          <a
            href='https://taskrush.com.br'
            target='_blank'
            rel='noopener noreferrer'
            className='cp-logo'
            aria-label='TaskRush'
          >
            <img alt='TaskRush' src={toAbsoluteUrl('/media/logos/taskrush.svg')} />
          </a>
          {isProjectPage && (
            <Link to='/area-do-cliente/dashboard' className='cp-btn'>
              <i className='bi bi-arrow-left' aria-hidden='true'></i>
              <span className='cp-btn-label'>Voltar aos projetos</span>
            </Link>
          )}
        </div>

        <div className='cp-header-right'>
          {user && (
            <>
              {selectedAccess && hasMultipleInstances && (
                <button
                  type='button'
                  className='cp-btn'
                  onClick={handleChangeAccess}
                  title='Trocar de empresa'
                >
                  <i className='bi bi-arrow-repeat' aria-hidden='true'></i>
                  <span className='cp-btn-label'>
                    {selectedAccess.instance?.name || `Empresa #${selectedAccess.instance_id}`}
                  </span>
                </button>
              )}
              <div className='cp-user'>
                <span className='cp-avatar' aria-hidden='true'>
                  {getInitials(user.name)}
                </span>
                <div className='cp-user-info'>
                  <span className='cp-user-name'>{user.name}</span>
                  <span className='cp-user-email'>{user.email}</span>
                </div>
              </div>
            </>
          )}
          <button type='button' className='cp-btn' onClick={handleLogout} aria-label='Sair'>
            <i className='bi bi-box-arrow-right' aria-hidden='true'></i>
            <span className='cp-btn-label'>Sair</span>
          </button>
        </div>
      </header>

      <main className='cp-main app-main flex-column flex-row-fluid'>
        <div className='d-flex flex-column flex-column-fluid'>{children}</div>
      </main>

      <footer className='cp-footer'>Portal do Cliente TaskRush</footer>
    </div>
  )
}

export {ClientPortalLayout}
